/* @ngInject */
function QuoteSectionTemplateFactory($http, $rootScope) {
  class QuoteSectionTemplate {
    constructor(data) {
      if (data) angular.extend(this, data);
    }

    static getResourceUrl() {
      return `${process.env.SERVER_URL}/api/secure/organization/${$rootScope.organization.slug}/quote-section-templates`;
    }

    static query(params) {
      return $http
        .get(QuoteSectionTemplate.getResourceUrl(), { params })
        .then((response) => response.data.map((quoteSectionData) => new QuoteSectionTemplate(quoteSectionData)));
    }

    create() {
      return $http
        .post(QuoteSectionTemplate.getResourceUrl(), this)
        .then((response) => angular.extend(this, response.data));
    }

    update() {
      return $http
        .put(`${QuoteSectionTemplate.getResourceUrl()}/${this._id}`, this)
        .then((response) => angular.extend(this, response.data));
    }

    delete() {
      return $http.delete(`${QuoteSectionTemplate.getResourceUrl()}/${this._id}`).then(() => true);
    }
  }

  return QuoteSectionTemplate;
}

export default QuoteSectionTemplateFactory;
